import React from "react";

const FilePreview = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M29.2 34H6.8A4.8 4.8 0 012 29.2V3.6A1.6 1.6 0 013.6 2H26a1.6 1.6 0 011.6 1.6v19.2H34v6.4a4.8 4.8 0 01-4.8 4.8zm-1.6-8v3.2a1.6 1.6 0 003.2 0V26h-3.2zM8.4 10v3.2h12.8V10H8.4zm0 6.4v3.2h12.8v-3.2H8.4zm0 6.4V26h8v-3.2h-8z"
            fill={fill}
        />
    </svg>
);

export default FilePreview;
